const cards = [
  {
    title: '访问安全指南',
    desc: '了解如何通过在线吃瓜官方线路安全访问，避免钓鱼网站与恶意跳转，保护个人隐私与设备安全。',
    tag: '安全必读',
    img: 'https://readdy.ai/api/search-image?query=Dark%20background%20with%20shield%20icon%20concept%2C%20abstract%20security%20and%20protection%20theme%2C%20warm%20amber%20glow%20accents%2C%20minimalist%20digital%20illustration%2C%20cybersecurity%20aesthetic%2C%20clean%20geometric%20shapes&width=800&height=480&seq=carousel-safety-01&orientation=landscape',
  },
  {
    title: '多线路切换技巧',
    desc: '掌握在主线路、备用网址之间快速切换的方法，确保在任何网络环境下都能顺畅访问在线吃瓜内容。',
    tag: '实用教程',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20network%20routing%20concept%20with%20multiple%20connected%20nodes%2C%20dark%20background%2C%20warm%20coral%20and%20amber%20glowing%20connection%20lines%2C%20modern%20tech%20minimalist%20style%2C%20clean%20geometric%20design&width=800&height=480&seq=carousel-switch-02&orientation=landscape',
  },
  {
    title: '移动端专属通道',
    desc: '在线吃瓜为手机用户打造了专属适配页面，更小的流量消耗、更快的加载速度、更好的阅读体验。',
    tag: '移动优先',
    img: 'https://readdy.ai/api/search-image?query=Smartphone%20with%20abstract%20digital%20content%20flowing%20out%2C%20dark%20atmosphere%2C%20warm%20accent%20lighting%2C%20modern%20mobile%20technology%20concept%2C%20minimalist%20design%2C%20clean%20composition%20on%20dark%20background&width=800&height=480&seq=carousel-mobile-03&orientation=landscape',
  },
  {
    title: '收藏本站不迷路',
    desc: '域名可能变化，但本站永久有效。将在线吃瓜加入浏览器收藏夹，随时获取最新有效入口地址。',
    tag: '永久收藏',
    img: 'https://readdy.ai/api/search-image?query=Bookmark%20or%20star%20icon%20with%20glowing%20warm%20light%2C%20dark%20background%2C%20abstract%20digital%20bookmark%20concept%2C%20minimalist%20design%2C%20amber%20and%20coral%20accent%20colors%2C%20clean%20modern%20aesthetic&width=800&height=480&seq=carousel-bookmark-04&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="flex items-center gap-3 mb-10">
          <span className="w-8 h-8 rounded-lg bg-secondary-500/15 flex items-center justify-center flex-shrink-0">
            <i className="ri-layout-masonry-line text-secondary-400"></i>
          </span>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-100">焦点专题</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {cards.map((card, i) => (
            <div key={i} className="group rounded-xl overflow-hidden bg-background-100 border border-background-300/30 hover:border-primary-500/20 transition-all duration-300 cursor-pointer">
              <div className="aspect-[5/3] overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                  }}
                />
              </div>
              <div className="p-4">
                <span className="inline-block px-2 py-0.5 rounded text-xs font-medium bg-primary-500/15 text-primary-400 mb-2">{card.tag}</span>
                <h3 className="text-sm md:text-base font-semibold text-foreground-200 mb-1">{card.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}